module.exports = __webpack_public_path__ + "img/macbook-retina.3a612399.png";